import { all, apply, put, takeLatest } from 'redux-saga/effects'
import { SnackBarMessageType } from '../../../components/layout/snackbar/index'
import { open } from '../snack.bar/actions'
import { IActionType, IAxiosResponse } from '../root.types'
import { NgoTypes, IActionCreate, IActionFind, IActionUpdate } from './types'
import {
    createNgoFailure,
    createNgoSuccess,
    loadNgoFailure,
    loadNgoSuccess,
    updateNgoFailure,
    updateNgoSuccess,
    findNgoFailure,
    findNgoSuccess
} from './actions'
import { Ngo } from '../../application/models/ngo/ngo'
import ngoService from '../../../services/ngo'

function* loadNgo(action: IActionType<any>) {
    try {
        const ngo: IAxiosResponse<Ngo> = yield apply(
            ngoService,
            ngoService.get,
            []
        )
        yield put(loadNgoSuccess(ngo))
    } catch (e) {
        yield put(loadNgoFailure())
    }
}

function* createNgo(action: IActionType<IActionCreate>) {
    try {
        const { ngo } = action.payload
        const reponse: IAxiosResponse<Ngo> = yield apply(
            ngoService,
            ngoService.create,
            [ngo]
        )
        yield put<any>(createNgoSuccess(reponse))
    } catch (e) {
        yield put(createNgoFailure())
    }
}

function* updateNgo(action: IActionType<IActionUpdate>) {
     try {
         const { ngo } = action.payload
         const ngoUpdated: IAxiosResponse<Ngo> = yield apply(
             ngoService,
             ngoService.updade,
             [ngo]
         )
 
         yield put<any>(updateNgoSuccess(ngoUpdated))
         yield put(
             open(
                 SnackBarMessageType.SUCCESS,
                 '',
                 `Alteração feito sucesso`)
         )
     } catch (e) {
         yield put(
             open(
                 SnackBarMessageType.ERROR,
                 '',
                 `Erro ao fazer a alteração`)
         )
         yield put(updateNgoFailure())
     }/**/

}
    function* findNgo(action: IActionType<IActionFind>) {
        try {
            const { ngoId } = action.payload
            const alert: IAxiosResponse<Ngo> = yield apply(
                ngoService,
                ngoService.getById,
                [ngoId]
            )
            yield put<any>(findNgoSuccess(alert))
        } catch (e) {
            yield put(findNgoFailure())
        }
    }

export default function* ngoSaga() {
    return yield all([
        takeLatest(NgoTypes.LOAD_NGO_REQUEST, loadNgo),
        takeLatest(NgoTypes.CREATE_NGO_REQUEST, createNgo),
        takeLatest(NgoTypes.UPDATE_NGO_REQUEST, updateNgo),
        takeLatest(NgoTypes.FIND_NGO_REQUEST, findNgo),
    ])
}